export default "https://cdn-static.gokick.com/assets/4215e61f258b66d5599ee2c3a2c4c86e46d29fa2/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";